import { loadable } from 'utils';

export const AddMultiple = loadable(() => import('./AddMultiple'), {});
